export default {
  totalVisualizacoes: state => state.totalVisualizacoes,
  totalClickTelefones: stage => stage.totalClickTelefones,
  totalMensagens: stage => stage.totalMensagens,
  quantidadeImoveis: stage => stage.quantidadeImoveis,
  graficoVisualizacoes: stage => stage.graficoVisualizacoes,
  mensagens3last: stage => stage.mensagens3last
}
